import './polyfill'
import 'expose-loader?$!expose-loader?jQuery!jquery'

import Vue from 'vue'
import moment from 'moment'
import VueCookies from 'vue-cookies'

import GnbHeader from './components/gnb/GnbHeader'
import GnbFooter from './components/gnb/GnbFooter'
import i18n from './i18n'
import CommonShare from './mixins/CommonShare'
import Constant from './mixins/Constant'
import store from './store'
import { namespace, types } from './store/modules/session-store'

import './assets/css/gnb.css'
import './common/web'

if (mode !== 'pc-gnb') {
  require('./common/reactive-web')
  require('./assets/css/gnb_mobile.css')
}

if (document.domain.indexOf('toast.com') !== -1) {
  document.domain = 'toast.com'
}

Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.event = event => {
      if (!(el == event.target || el.contains(event.target))) {
        vnode.context[binding.expression](event)
      }
    }
    document.body.addEventListener('click', el.event)
  },
  unbind(el) {
    document.body.removeEventListener('click', el.event)
  }
})
Vue.mixin(CommonShare)
Vue.mixin(Constant)

Vue.use(VueCookies)

Vue.filter('date', function(value, format) {
  return moment(value).format(format)
})

export function drawGnbHeader(options) {
  const app = new Vue({
    store,
    i18n,
    ...GnbHeader,
    propsData: {
      ...options
    }
  })

  app.$mount('#toast-gnb-header')
}

export function drawGnbFooter(options) {
  const app = new Vue({
    store,
    i18n,
    ...GnbFooter,
    propsData: {
      ...options
    }
  })

  app.$mount('#toast-gnb-footer')
}

export function getSessionWithCountry() {
  return store.dispatch(`${namespace}/${types.GET_SESSION_WITH_COUNTRY}`)
}
